import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import shortid from 'shortid';
import Slide from './Sliders/ProjectSlide';
import SearchGallery from './SearchGallery';

class Search extends PureComponent {
  getSearchProjects() {
    const { location, projects } = this.props;
    if (location.state && location.state.projects) {
      return location.state.projects;
    }
    return projects;
  }

  createElement(project) {
    return (
      <li key={`li-${shortid.generate()}`}>
        <Slide project={project} slider={this} canTap />
      </li>
    );
  }

  searchElements() {
    const elements = [];

    const projects = this.getSearchProjects();

    elements.push(projects.map(project => this.createElement(project)));
    return elements;
  }

  render() {
    return (
      <div>
        <div className="search search--center">
          <SearchGallery projects={this.searchElements()} />
        </div>
        <div className="search--padding" />
      </div>
    );
  }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/components/Search.js